;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import { providerNameParts, resolveFullDisplayName } from "../../../../lib/names"
import get from "lodash/get"
import uniqBy from "lodash/uniqBy"
import sortBy from "lodash/sortBy"
import Link from "next/link"
import InPersonIcon from "../shared/icons/InPersonIcon"
import ViewGroupButton from "./ViewGroupButton"
import ProviderSection from "./ProviderSection"
import GroupPicture from "./GroupPicture"
import GroupCardDate from "./GroupCardDate"
import {
  UI_STYLE_PRIMARY_BLUE_BLACK,
  COHORT_PRICE_TYPE_PER_SESSION,
  COHORT_PRICE_TYPE_ALL_UPFRONT,
} from "../../../../lib/constants"
import getReadableGroupType from "../../../../lib/formatter/getReadableGroupType"
import { buildGroupPath } from "../../../../lib/publicRoutes/buildPaths"
import getPrimaryCredentialAndRole from "../../../../lib/provider/getPrimaryCredentialAndRole"
import { getRoleDisplay } from "../../../../lib/provider/credentialUtils"
// width of the cards are 349px
// const CARD_WIDTH = 349
// const CARD_MARGIN_RIGHT = 36

export default function GroupCard({
  city,
  cohortLocations,
  cohortNextStartsAt,
  cohortId,
  groupDescription,
  groupId,
  groupPublicId = null,
  groupVanitySlug = null,
  groupName,
  groupPhotoUrl,
  groupType,
  joinableCohortCount,
  priceType,
  priceValue,
  providerFirstName,
  providerLastName,
  providerPhotoUrl,
  providerPreferredFirstName,
  providerPreferredLastName,
  providerPrimaryCredential,
  providerPrimaryRole,
  providerTitle,
  settingInPerson,
  settingVirtual,
  state,
  index,
  priority = false,
  geographicListing = false,
}) {
  const physicalLocationCohortCount = get(cohortLocations, "length", 0)
  const renderTopHat = () => {
    const readableGroupType = getReadableGroupType({ group: { type: groupType } })
    return (
      <div
        className={`flex flex-row justify-between items-center h-[38px] bg-[#00B2FF] tracking-7 text-white rounded-[12px_12px_0_0] px-[20px]`} // w - padding
      >
        <div className="text-16px">{readableGroupType}</div>
        {/* Timezone-relative date rendered as a client island (see GroupCardDate)
            so the rest of this card can be a Server Component. */}
        <GroupCardDate cohortNextStartsAt={cohortNextStartsAt} />
      </div>
    )
  }
  const getViewGroupButtonText = () => {
    if (geographicListing && !(joinableCohortCount > 0)) {
      return "Contact about participation"
    }
    // test group
    if (false) {
      return "View Example Group"
    }
    if (joinableCohortCount > 1) {
      return `View ${joinableCohortCount} booking options`
    } else {
      return "View group booking"
    }
  }

  const renderJoinCohortButton = () => {
    // No need for href bc card has href
    return (
      <div className="mt-[15px]">
        <ViewGroupButton
          // href={`/group/${groupId}`}
          text={getViewGroupButtonText()}
        />
      </div>
    )
  }

  const renderGroupPicture = () => {
    return (
      <GroupPicture
        groupPhotoUrl={groupPhotoUrl}
        settingInPerson={settingInPerson}
        settingVirtual={settingVirtual}
        priority={priority}
      />
    )
  }
  const renderGroupName = () => {
    return (
      <div
        className={
          "font-bold	leading-[23px] tracking-[.19px] text-[19px] text-black pb-[10px]"
        }
      >
        {groupName}
      </div>
    )
  }
  const renderGroupDescription = () => {
    return (
      <div className={"text-[#7A7A7A] text-[19px] tracking-[.54px] leading-[140%]"}>
        {groupDescription}
      </div>
    )
  }

  const renderPhysicalLocation = ({ text, locationIndex }) => {
    return (
      <div
        key={`${index}-${locationIndex}`}
        className={"flex flex-row items-center py-[2.5px]"}
      >
        <div className="bg-[#F2F2F2] rounded-full h-[25px] w-[25px] flex justify-center items-center mr-[6px]">
          <InPersonIcon isGroupCard={true} color={UI_STYLE_PRIMARY_BLUE_BLACK} />
        </div>
        <div className="text-[#AAAAAA] text-[16px]">{`${text}`}</div>
      </div>
    )
  }
  const reorderCohortLocations = (primaryCity, primaryState, cohortLocations) => {
    // Remove duplicates
    const uniqueCohortLocations = uniqBy(
      cohortLocations,
      (location) => `${location.city}-${location.state}`,
    )

    // Reorder locations
    return sortBy(uniqueCohortLocations, [
      (location) => {
        return location.city === primaryCity && location.state === primaryState
          ? 0
          : 1
      },
    ])
  }

  const renderPhysicalLocations = () => {
    if (physicalLocationCohortCount === 0) {
      return null
    }
    const reorderedCohortLocs = reorderCohortLocations(city, state, cohortLocations)
    let locationsToRender = []

    if (physicalLocationCohortCount > 3) {
      locationsToRender = reorderedCohortLocs.slice(0, 2) // First 2 locations
    } else {
      locationsToRender = [...reorderedCohortLocs] // All locations
    }

    return (
      <div className={"flex flex-row flex-wrap justify-between "}>
        {locationsToRender.map(({ city, state }, locationIndex) => {
          return renderPhysicalLocation({ text: `${city}, ${state}`, locationIndex })
        })}
        {physicalLocationCohortCount > 3 &&
          renderPhysicalLocation({
            text: `+${physicalLocationCohortCount - 2} cities`,
            locationIndex: "extra",
          })}
      </div>
    )
  }
  const getPriceUnitString = () => {
    if (priceType === COHORT_PRICE_TYPE_PER_SESSION) {
      return "session"
    }
    if (priceType === COHORT_PRICE_TYPE_ALL_UPFRONT) {
      return "group"
    }
    return "Unknown"
  }
  const renderPrice = () => {
    const hasPublishedPrice =
      typeof priceValue === "number" &&
      Number.isFinite(priceValue) &&
      priceValue >= 0 &&
      (priceType === COHORT_PRICE_TYPE_PER_SESSION ||
        priceType === COHORT_PRICE_TYPE_ALL_UPFRONT)
    const label =
      geographicListing && !hasPublishedPrice
        ? "Contact for pricing"
        : `$${priceValue / 100}/${getPriceUnitString()}`
    return (
      <div className={"flex flex-row items-center h-[30px]"}>
        <div className="text-[#AAAAAA] text-[16px] font-bold tracking-[0.48px]">
          {label}
        </div>
      </div>
    )
  }
  const renderLocationAndPriceRow = () => {
    return (
      <div
        className={`flex flex-row flex-wrap justify-between ${
          physicalLocationCohortCount === 0 ? "mt-[10px]" : "mt-[10px]"
        }`}
      >
        {renderPhysicalLocations()}
        {renderPrice()}
      </div>
    )
  }
  const getProviderDisplayName = () => {
    const name = resolveFullDisplayName(
      providerNameParts({
        providerFirstName,
        providerLastName,
        providerPreferredFirstName,
        providerPreferredLastName,
      }),
    )
    return providerTitle ? `${providerTitle} ${name}` : name
  }
  // const getDisplayCredentialAndRole = (
  //   providerPrimaryCredential,
  //   providerPrimaryRole,
  // ) => {
  //   // If providerPrimaryCredential exists, concatenate it with providerPrimaryRole
  //   if (providerPrimaryCredential) {
  //     return `${providerPrimaryCredential} ${providerPrimaryRole}`
  //   }

  //   // Otherwise, return only the providerPrimaryRole
  //   return providerPrimaryRole
  // }
  const renderProviderSection = () => {
    return (
      <ProviderSection
        providerDisplayName={getProviderDisplayName()}
        primaryCredentialAndRole={getPrimaryCredentialAndRole({
          providerPrimaryCredential,
          providerPrimaryRole: getRoleDisplay(providerPrimaryRole),
        })}
        providerPicture={providerPhotoUrl}
      />
    )
  }
  const renderBottomPartOfCard = () => {
    return (
      <div
        className={
          "bg-white flex flex-col p-[15px_20px_23px_20px] border-x-[1px] border-b-[1px] border-t-0 border-solid border-[#E0DEDE] rounded-b-[15px]" // width is full width - padding - border
        }
      >
        {renderGroupName()}
        {renderGroupDescription()}
        {renderProviderSection()}
        {renderLocationAndPriceRow()}

        {renderJoinCohortButton()}
      </div>
    )
  }
  return (
    <div className={`flex justify-start items-center flex-col`}>
      <Link
        className={`flex w-[349px] max-w-[calc(100vw-20px)] flex-col overflow-hidden rounded-[12px_12px_15px_15px] border-[1px] border-solid border-white font-roboto text-16px tracking-3 text-black no-underline hover:border-black hover:shadow-[0_4px_4px_rgba(0,0,0,0.25)]`}
        href={
          buildGroupPath({
            type: groupType,
            vanitySlug: groupVanitySlug,
            publicId: groupPublicId,
            id: groupId,
          }) || `/group/${groupId}`
        }
        // key={`${index}-group-card`}
      >
        {renderTopHat()}
        {renderGroupPicture()}
        {renderBottomPartOfCard()}
      </Link>
    </div>
  )
}
